// src/api.js

const API_BASE = "/api";
let refreshPromise = null;

async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = fetch(`${API_BASE}/auth/refresh`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    })
      .then(response => response.ok)
      .catch(() => false)
      .finally(() => { refreshPromise = null; });
  }
  return refreshPromise;
}


async function parseError(res) {
  let text = "";
  try {
    text = await res.text();
  } catch (_) {
    // ignore
  }

  // Try JSON
  try {
    const j = JSON.parse(text);
    if (j && typeof j === "object") {
      if (j.detail) {
        if (typeof j.detail === "string") return `${res.status} ${res.statusText}: ${j.detail}`;
        // FastAPI sometimes returns detail as array
        return `${res.status} ${res.statusText}: ${JSON.stringify(j.detail)}`;
      }
      return `${res.status} ${res.statusText}: ${JSON.stringify(j)}`;
    }
  } catch (_) {
    // ignore
  }

  if (text) return `${res.status} ${res.statusText}: ${text}`;
  return `${res.status} ${res.statusText}`;
}

async function request(method, path, body) {
  const opts = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  if (body !== undefined) {
    opts.body = JSON.stringify(body);
  }

  let res = await fetch(`${API_BASE}${path}`, opts);

  const canRefresh = !["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"].includes(path);
  if (res.status === 401 && canRefresh && await refreshSession()) {
    res = await fetch(`${API_BASE}${path}`, opts);
  }

  if (!res.ok) {
    throw new Error(await parseError(res));
  }

  // Some endpoints return empty body
  const ct = res.headers.get("content-type") || "";
  if (ct.includes("application/json")) return res.json();
  return res.text();
}

async function requestBlob(method, path, body) {
  const opts = {
    method,
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  };

  if (body !== undefined) {
    opts.body = JSON.stringify(body);
  }

  let res = await fetch(`${API_BASE}${path}`, opts);

  if (res.status === 401 && await refreshSession()) {
    res = await fetch(`${API_BASE}${path}`, opts);
  }

  if (!res.ok) {
    throw new Error(await parseError(res));
  }

  return res.blob();
}

export function apiGet(path) {
  return request("GET", path);
}

export function apiPost(path, body) {
  return request("POST", path, body);
}

export function apiPut(path, body) {
  return request("PUT", path, body);
}

export function apiPostBlob(path, body) {
  return requestBlob("POST", path, body);
}

export function apiPatch(path, body) {
  return request("PATCH", path, body);
}

export function apiDelete(path) {
  return request("DELETE", path);
}